// Characters Context — Public API (client-safe)
// For server-only services/repositories, use '@/contexts/characters/server'

// Types
export type { Character, CharacterPortrait, CharacterTemplate } from './types';
export type { CreateCharacterTemplateInput, UpdateCharacterTemplateInput } from './types';
export { CharacterRole, CharacterGender, CharacterCreationMethod, PortraitStyle } from './types';

// Hooks
export { useCharacters, useStoryCharacters } from './hooks/useCharacters';
export { useCharacter } from './hooks/useCharacter';
export { useCharacterMutations } from './hooks/useCharacterMutations';

// Components
export { CharacterSelector } from './components/CharacterSelector';
export type { CharacterAssignment, CharacterSelectorHandle } from './components/CharacterSelector';
export { CharacterForm } from './components/CharacterForm';
export { CharacterFormContent } from './components/CharacterFormContent';
export type { CharacterFormContentProps } from './components/CharacterFormContent';
export { CharacterCard } from './components/CharacterCard';
export { CharacterListItem } from './components/CharacterListItem';
export { PhotoConsentCheckbox } from './components/PhotoConsentCheckbox';
export { CharacterPickerSheet } from './components/CharacterPickerSheet';
export { CharacterLibraryClient } from './components/CharacterLibraryClient';
export { VoiceLibraryClient } from './components/VoiceLibraryClient';

// Actions
export { createCharacter } from './actions/createCharacter';
export { uploadHeroPhotoDraft } from './actions/uploadHeroPhotoDraft';
export { saveVoiceCharacters } from './actions/saveVoiceCharacters';
export type {
  VoiceCharacterInput,
  SaveVoiceCharactersPayload,
} from './actions/saveVoiceCharacters';
export { getStoryCharacters } from './actions/getStoryCharacters';
export type { StoryCharacterGroup } from './actions/getStoryCharacters';
export { getCharacterAppearances } from './actions/getCharacterAppearances';
export type { CharacterAppearance } from './actions/getCharacterAppearances';
export { setCharacterAppearance } from './actions/setCharacterAppearance';
export { seedCharactersFromTemplates } from './actions/seedCharactersFromTemplates';
export {
  listActiveCharacterTemplates,
  listAllCharacterTemplates,
  createCharacterTemplate,
  updateCharacterTemplate,
  deleteCharacterTemplate,
  reorderCharacterTemplates,
  setCharacterTemplateActive,
} from './actions/characterTemplates';

// Navigation
export { charactersNavItems } from './navigation';

// Query Keys
export { characterKeys } from './queryKeys';
export type { CharacterScope } from './queryKeys';
